import React, { useEffect, useState } from 'react';

interface CounterInterface {
  counter?:number;
  index?:number;
  onChange?:(value:any,  index:any)=>void;
}

const Counter: React.FC<CounterInterface> = ({counter, index, onChange}) => {
  const [count, setCount] = useState<number>(0);

  const increment = () => setCount(count + 1);
  const decrement = () => setCount(count > 1 ? count - 1 : 1); // Ensure count doesn't go below 1

  useEffect(()=>{
    if(onChange)
      onChange(count, index)
  },[count])

  useEffect(()=>{
    console.log({counter})
    setCount(counter!)
  },[counter])

  return (
    <div className="inline-block bg-gray-800  text-white rounded-full p-1">
      <button
        onClick={decrement}
        className="lg:px-3 px-1 bg-transparent text-white lg:text-xl font-bold focus:outline-none"
      >
        -
      </button>
      <span className="mx-1 text-lg font-semibold">{count}</span>
      <button
        onClick={increment}
        className="lg:px-3 px-1 bg-transparent text-white lg:text-xl font-bold focus:outline-none"
      >
        +
      </button>
    </div>
  );
}

export default Counter;
